import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import * as common from "../../common/common";
import http from "../../common/http-common";
import * as Comp from "../../common/CommonComponents";

import "../../App.css";
// import Logo from "../../Logo.png";

const LoginModal = (props) => {
  // const userIdInputRef = useRef();
  const emailInputRef = useRef();
  const userPasswordInputRef = useRef();

  const [loginData, setLoginData] = useState([]);
  const [inputError, setInputError] = useState([]);

  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    var inputText = document.getElementById("PASSWORD");
    var loginBtn = document.getElementById("btnLogin");
    if (inputText && loginBtn) {
      inputText.onkeydown = (e) => {
        if (e.key === "Enter") loginBtn.click();
      };
    }
  }, []);

  const hideModal = () => {
    setLoginData([]);
    setInputError([]);
    setErrorMsg("");
    props.onHide();
  };

  const modalOnEsc = () => {
    // do nothing
  };

  const ForgetPasswordOnClick = () => {
		ForgetPassword();
	}

	function ForgetPassword() {
		props.removeCookies();
		let functionName = "Forget Password";
		hideModal();
		props.showHideForgetModal();
	}

  const loginBtnOnClick = () => {
    // if (loginData.USER_ID === undefined) {
    //   setInputError((prevState) => ({
    //     ...prevState,
    //     USER_ID: " User ID could not be empty.",
    //   }));
    // }

    if (loginData.EMAIL === undefined) {
      setInputError((prevState) => ({
        ...prevState,
        EMAIL: " Email could not be empty.",
      }));
    }
    if (loginData.PASSWORD === undefined) {
      setInputError((prevState) => ({
        ...prevState,
        PASSWORD: " Password could not be empty.",
      }));
    }
    if (Object.values(inputError).filter((v) => v !== "").length === 0) {
      UserLogin();
    }
  };

  function UserLogin() {
    props.removeCookies();
    if (
      /*loginData.USER_ID !== undefined &&*/
      loginData.EMAIL !== undefined &&
      loginData.PASSWORD !== undefined
    ) {
      let functionName = "";
      try {
        functionName = "User Login";
        props.onLoading(true, "Logging in, please wait...");
        var encrypted = common.c_EncryptData(loginData.PASSWORD.trim());
        const data = {
          // USER_ID: loginData.USER_ID.trim(),
          EMAIL: loginData.EMAIL.trim(),
          PASSWORD: encrypted.toString(),
        };
        http
          .post("api/login/UserLogin", data, { timeout: 100000 })
          .then((response) => {
            if (response.data.VALID === "LOGIN_SUCCESS") {
              props.setCookies("USER_NAME", response.data.USER_SHORT_NAME, {
                path: "/",
              });
              props.setCookies("USER_ID", response.data.USER_ID, {
                path: "/",
              });
              props.setCookies("EMAIL", response.data.EMAIL, {
                path: "/",
              });
              props.setCookies("ORG_NAME", response.data.ORG_NAME, {
                path: "/",
              });
              // props.setCookies(
              //   "AUTO_LOGOUT_DURATION",
              //   response.data.AUTO_LOGOUT_DURATION,
              //   { path: "/" }
              // );
              window.location = common.c_getWebUrl() + "Home";
              hideModal();
            } else if (response.data.VALID === "RESET") {
              props.setResetData({
                USER_ID: response.data.USER_ID,
                EMAIL: response.data.EMAIL,
                USER_NAME: response.data.USER_SHORT_NAME,
                ERROR_MSG: response.data.ERROR_MSG,
              });
              hideModal();
              props.showHideResetModal();
            } else {
              setErrorMsg(response.data.ERROR_MSG);
            }
          })
          .catch((err) => {
            setErrorMsg("Failed to log in. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          })
          .finally(() => {
            props.onLoading(false, "Loading...");
          });
      } catch (err) {
        props.onLoading(false, "Loading...");
        setErrorMsg("Failed to log in. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    }
  }

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
      setLoginData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  return (
    <>
      <Modal show={props.showHide} onHide={modalOnEsc} centered>
        <Modal.Header style={{ display: "flex", flexDirection: "column" }}>
          <div>
            <img
              src={props.images["Cimation Ticketing System.jpeg"]}
              style={{ width: "70%", marginLeft: "15%", marginRight: "15%"}}
              alt="cimation"
            />
          </div>
          {/* <h3>Sign In</h3> */}
        </Modal.Header>
        <Modal.Body>
          <div style={{marginBottom: "20px"}}>
            <Comp.Input
              ref={emailInputRef}
              id="EMAIL"
              name="Email"
              type="email"
              className="form-control"
              errorMessage={inputError.EMAIL}
              value={loginData.EMAIL}
              onChange={inputRequiredHandler}
              placeholder="EMAIL"
            />
          </div>
          
          <div style={{marginBottom: "20px"}}>
            <Comp.Input
              ref={userPasswordInputRef}
              id="PASSWORD"
              name="Password"
              type="password"
              className="form-control"
              errorMessage={inputError.PASSWORD}
              value={loginData.PASSWORD}
              onChange={inputRequiredHandler}
              placeholder="PASSWORD"
            />
          </div>

          <button 
						id="ForgetPassword" 
						onClick={ForgetPasswordOnClick}
						style={
							{ border: "none", backgroundColor: "transparent", textDecoration: "underline", cursor: "pointer"}}>
						Forgot Password?
					</button>

          {/* <div
            style={{
              display: "flex",
              margin: "1rem 3rem",
            }}
          >
            <label>Email</label>
            <Comp.Input
              ref={emailInputRef}
              id="EMAIL"
              name="Email"
              type="email"
              errorMessage={inputError.EMAIL}
              value={loginData.EMAIL}
              onChange={inputRequiredHandler}
              // placeholder="EMAIL"
            />
          </div>
          <div
            style={{
              display: "flex",
              margin: "1rem 3rem",
            }}
          >
            <label>Password</label>
            <Comp.Input
              ref={userPasswordInputRef}
              id="PASSWORD"
              name="Password"
              type="password"
              errorMessage={inputError.PASSWORD}
              value={loginData.PASSWORD}
              onChange={inputRequiredHandler}
              // placeholder="PASSWORD"
            />
          </div> */}
        
        </Modal.Body>
        <Modal.Footer>
          <div
            style={{ textAlign: "center", width: "100%", marginBottom: "0" }}
          >
            <Comp.Button 
              id="btnLogin"
              type="submit" 
              style={{width: "100%"}} 
              onClick={loginBtnOnClick}
            >
              LOGIN
            </Comp.Button>
            <p
              style={{
                color: "rgb(255,0,0)",
                marginTop: "5px",
                fontSize: "smaller",
                marginBottom: "0",
              }}
            >
              {errorMsg}
            </p>
            <p
              style={{
                marginBottom: "0",
                fontSize: "smaller",
              }}
            >
              Copyright © 2025 by Cimation (M) Sdn. Bhd. All rights reserved.
            </p>
          </div>
        </Modal.Footer>
      </Modal>
    </>

    // <div className="Auth-form-container">
    //   <form className="Auth-form" onSubmit={submitFormHandler}>
    //     <div className="Auth-form-content">
    //       <h3 className="Auth-form-title">Sign In</h3>
    //       <div className="form-group mt-3">
    //         {/* <label>Username</label> */}
    //         <Comp.Input
    //           ref={userIdInputRef}
    //           id="USER_ID"
    //           type="text"
    //           name="User ID"
    //           // className="form-control mt-1"
    //           className="form-control"
    //           errorMessage={inputError.USER_ID}
    //           value={loginData.USER_ID}
    //           onChange={inputRequiredHandler}
    //           placeholder="USER ID"
    //         />
    //         {/* {renderErrorMessage("username")} */}
    //       </div>
    //       <div className="form-group mt-3">
    //         {/* <label>Password</label> */}
    //         <Comp.Input
    //           ref={userPasswordInputRef}
    //           id="PASSWORD"
    //           type="password"
    //           name="Password"
    //           // className="form-control mt-1"
    //           className="form-control"
    //           errorMessage={inputError.PASSWORD}
    //           value={loginData.PASSWORD}
    //           onChange={inputRequiredHandler}
    //           placeholder="PASSWORD"
    //         />
    //         {/* {renderErrorMessage("pwd")} */}
    //       </div>
    //       <div className="d-grid gap-2 mt-3">
    //         <button
    //           type="submit"
    //           className="btn btn-primary"
    //           // onClick={loginBtnOnClick}
    //         >
    //           Login
    //         </button>
    //         <p
    //           style={{
    //             color: "rgb(255,0,0)",
    //             marginTop: "5px",
    //             fontSize: "smaller",
    //           }}
    //         >
    //           {errorMsg}
    //         </p>
    //       </div>
    //       <p className="text-center mt-2">
    //         Forgot <a href="#">password?</a>
    //       </p>
    //     </div>
    //   </form>
    // </div>
  );
};

export default LoginModal;
